import { Component, EventEmitter, Output } from '@angular/core';
import { Button } from '../../../../shared/components/button/button';

@Component({
  selector: 'app-why-semnexus',
  imports: [Button],
  templateUrl: './why-semnexus.html',
  styleUrl: './why-semnexus.scss'
})
export class WhySemnexus {

  @Output()
  public goToSection = new EventEmitter<string>();


}
